import StudentSignUp from './StudentSignup';
import TeacherSignUp from './TeacherSignup';

export { StudentSignUp, TeacherSignUp };
